import CourseSettingsService from 'services/course-settings-service';

export default () => {
  if(!EF.options.local) {
    setTimeout(() => {
      const portalBasePath = CourseSettingsService.get('portalBasePath');
      if(portalBasePath) {
        const headers = new Headers();
        headers.set('Accept', 'application/json');
        fetch(`${portalBasePath}/heartbeat`, { headers, credentials: 'include' });
      }
    }, 0);
  }
};
